import { render, staticRenderFns } from "./ResultsDesktop.vue?vue&type=template&id=3a4de8ce&scoped=true&"
import script from "./ResultsDesktop.vue?vue&type=script&lang=js&"
export * from "./ResultsDesktop.vue?vue&type=script&lang=js&"
import style0 from "./ResultsDesktop.vue?vue&type=style&index=0&id=3a4de8ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4de8ce",
  null
  
)

export default component.exports